import { render, staticRenderFns } from "./_addoredit copy.vue?vue&type=template&id=15bbab3a&"
import script from "./_addoredit copy.vue?vue&type=script&lang=js&"
export * from "./_addoredit copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports